import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export function Input({ className, type, ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      className={cn(
        'flex h-9 w-full rounded-md border bg-[var(--color-background)] px-3 py-1 text-sm shadow-sm transition-colors',
        'placeholder:text-[var(--color-muted-foreground)] outline-none focus-visible:ring-[3px] focus-visible:ring-[var(--color-ring)]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  );
}
